<template>
	<div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Nome *</label>
		        <input
		        	type="text"
		        	class="form-control"
		        	v-model="dados.nome"
		        	:id="name+'nome'"
		        	@input="clearValidation('nome')">
		        <div
		        	class="invalid-feedback"
		        	:id="name+'nome-invalid-feedback'">
		        </div>
		    </div>
		</div>
		<div class="form-row">
		    <div class="form-group col-md-12">
		        <label>Descrição</label>
		        <vue-editor v-model="dados.descricao"></vue-editor>
		    </div>
		</div>
		<div class="form-row">
			<div class="form-group col-md-6">
				<label>Unidade de Medida</label>
		        <select-two
		        	:options="medidas"
		        	:formId="name+'unidade_medida_id'"
		        	:valueDefault="dados.medida"
		        	@selected="setMedidaId"
		        	@searching="getMedidas"
		        	@noValue="setMedidaId('')"
		        	arrayValue="nome">
		        </select-two>
		        <div
		        	class="invalid-feedback"
		        	:id="name+'cliente_id-invalid-feedback'">
		        </div>
			</div>
			<div class="form-group col-md-6">
				<label>Quantidade</label>
		        <input
		        	type="number"
		        	class="form-control"
		        	v-model="dados.quantidade"
		        	:id="name+'quantidade'"
		        	@input="clearValidation('quantidade')">
		        <div
		        	class="invalid-feedback"
		        	:id="name+'quantidade-invalid-feedback'">
		        </div>
			</div>
		</div>
		<div class="form-row">
			<div class="form-group col-md-4">
		        <label>Categoria</label>
		        <select-two
		        	:options="categorias"
		        	:formId="name+'categoria_id'"
		        	:valueDefault="categoria"
		        	@selected="setCategoriaId"
		        	@searching="getCategorias"
		        	@noValue="setCategoriaId('')"
		        	arrayValue="nome">
		        </select-two>
		        <div
		        	class="invalid-feedback"
		        	:id="name+'cliente_id-invalid-feedback'">
		        </div>
		    </div>
		    <div class="form-group col-md-4">
		        <label>Data *</label>
		        <input
		        	type="date"
		        	class="form-control"
		        	v-model="dados.data"
		        	:id="name+'data'"
		        	@input="clearValidation('data')">
		        <div
		        	class="invalid-feedback"
		        	:id="name+'data-invalid-feedback'">
		        </div>
		    </div>
		    <div class="form-group col-md-4">
		        <label>Valor *</label>
                <money
                    :id="name+'valor'"
                    class="form-control"
                    v-model="dados.valor"
                    @input="clearValidation('valor')">
                </money>
		        <div
		        	class="invalid-feedback"
		        	:id="name+'valor-invalid-feedback'">
		        </div>
		    </div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dados', 'name', 'errors', 'categoria'],
		data(){
			return {
				elementos: Object.keys(this.dados),
				categorias: [],
				medidas: [],
			}
		},
		created(){
			this.getDados();
		},
		methods : {
			getDados(){
				this.getCategorias();
				this.getMedidas();
			},
			getCategorias(pesquisa=''){
				axios.get(this.$url+'/api/adm/categ-despesas/data?pesquisa='+pesquisa)
	            .then(response => {
	                this.categorias = response.data.data.data
	            })
			},
			setCategoriaId(valor){
				this.dados.categoria_id = valor.id;
			},
			getMedidas(pesquisa=''){
				axios.get(this.$url+'/api/adm/unidades-medida/data?pesquisa='+pesquisa)
	            .then(response => {
	                this.medidas = response.data.data.data
	            })
			},
			setMedidaId(valor){
				this.dados.unidade_medida_id = valor.id;
			},
			clearValidation(element){
				this.$bshValidation.clear(element, this.name);
			}
        },
        watch: {
            errors: function() {
                this.$bshValidation.valide(this.elementos, this.errors, this.name);
            }
        }
    }
</script>
